<div class="landing-dialog-wrapper hoverevents" [ngClass]="style">
  <div class="landing-dialog-close-button-container">
    <button class="landing-dialog-close-button" tabindex="-1" (click)="onDialogClose()">&times;</button>
  </div>
  <ng-content></ng-content>
</div>
